export default __webpack_public_path__ + "static/media/organic (1).b230c521.png";